import { useContext } from "react";

import { useProjectPermissionsQuery } from "@/queries/query-project-permission";
import { ProjectContext } from "@/stores/project-provider";

// No project_write === don't show the buttons
// No project_manage === disable the buttons

export function useProjectActionAllowed() {
  const { id: projectId } = useContext(ProjectContext);
  const projectPermissionsQuery = useProjectPermissionsQuery(projectId);

  return {
    permissionsLoading: projectPermissionsQuery.isLoading,
    canManageProject: projectPermissionsQuery.data?.project_manage ?? false, // Can change the settings of a project
    canWriteProject: projectPermissionsQuery.data?.project_write ?? false, // Can write to a project (add files, run proccesses.)
  };
}
